import enUS from 'antd/lib/locale/en_US';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import React, { useEffect, useState } from 'react';
import UsersProvider from './context/users';
import { store } from './store';
import IntercomWidget from './Widget';

import Routes from './routes';
import NotificationsProvider from './context/notifications';
import Auth, { AuthContext } from './context/auth';

import './App.less';

const App = (): JSX.Element => {
  const [, refreshAuth] = useState({});

  useEffect(() => {
    Auth.change = (): void => refreshAuth({});
  }, []);

  return (
    <Provider store={store}>
      <NotificationsProvider>
        <AuthContext.Provider value={Auth}>
          <UsersProvider>
            <ConfigProvider locale={enUS}>
              <IntercomWidget />
              <Routes />
            </ConfigProvider>
          </UsersProvider>
        </AuthContext.Provider>
      </NotificationsProvider>
    </Provider>
  );
};

export default App;
